"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegerMarshaller = void 0;
const zod_1 = require("zod");
const ZodExtensions_1 = require("./ZodExtensions");
function parseBigInt(value) {
    try {
        return BigInt(value);
    }
    catch (e) {
        return undefined;
    }
}
function bigIntToFloat(value) {
    //ensure it won't overflow
    if (typeof value !== 'undefined' && value > BigInt(Number.MIN_SAFE_INTEGER) && value < BigInt(Number.MAX_SAFE_INTEGER)) {
        return Number(value);
    }
    return NaN;
}
/* eslint-disable @typescript-eslint/no-explicit-any */
const IntegerMarshaller = (v, options) => {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    let resolved;
    return v.superRefine((val, ctx) => {
        const originalVal = val;
        const valueType = typeof val;
        if (ZodExtensions_1.isNullish(val)) {
            if (options?.nullable === true) {
                resolved = val;
            }
            else {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.invalid_type,
                    message: 'value must not be nullish',
                    expected: 'unknown',
                    received: valueType,
                });
            }
            return;
        }
        if (valueType === 'string') {
            if (val.length === 0) {
                if (options?.nullable
                    && 'emptyStringAsNull' in options
                    && options?.emptyStringAsNull === true) {
                    resolved = null;
                    return;
                }
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.too_small,
                    message: 'string value must not be an empty string',
                    minimum: 1,
                    inclusive: true,
                    type: 'string',
                });
                return;
            }
            val = parseFloat(val)
                || parseInt(val)
                || bigIntToFloat(parseBigInt(val));
        }
        switch (typeof val) {
            case 'number':
                if (isNaN(val)) {
                    ctx.addIssue({
                        code: zod_1.z.ZodIssueCode.invalid_type,
                        message: `value "${originalVal}" cannot be parsed as a number`,
                        expected: 'number',
                        received: valueType,
                    });
                }
                else if (!Number.isInteger(val)) {
                    ctx.addIssue({
                        code: zod_1.z.ZodIssueCode.custom,
                        message: `value "${val}" (${typeof val}) is not an integer`,
                    });
                }
                else {
                    resolved = val;
                }
                break;
            default:
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.invalid_type,
                    message: 'value must be a number or a string represeting a number',
                    expected: 'number',
                    received: valueType,
                });
                break;
        }
    }).transform(() => resolved);
};
exports.IntegerMarshaller = IntegerMarshaller;
//# sourceMappingURL=ZodIntegerMarshaller.js.map